<template>
<div id="contents">

  <div id="company" class="page_contents">

    <div id="company_contents">
      <div id="company_history">
        <div class="page_header">
          <h1 class="page_header_title">
            <img src="../assets/img/company/title.png" width="359" alt="WORKS" />
            <span>会社について</span>
          </h1><!-- .top_sec_title -->
        </div><!-- .page_header -->

        <companyPageNav />

        <div id="company_history_main" class="page_main_contents">
          <ul v-for="history in history_list_add_jp_year" :key="history.post_id" class="history_list">
            <li>{{ history.jp_year }} {{ history.content }}</li>
          </ul>

        </div><!-- #company_history_main -->


      </div><!-- #company_history -->
    </div><!-- #company_contents -->
  </div><!-- #company -->



</div><!-- #contents -->
</template>

<script>
import companyPageNav from './shared/companyPageNav.vue'
export default {
  name: 'history_index',
  components: {
    companyPageNav
  },
  data(){
    return {
      api_url: this.$parent.api_base_url+'/api/history/index.php',
      history_list: null,
      error: null
    }
  },
  computed: {
    history_list_add_jp_year: function () {
      if(this.history_list){
        return this.history_list.filter(function (history) {
          var year = history.date
          if (year > 2018) {
            return year-2018 == 1 ? history.jp_year = year+"（平成31・令和1）" : history.jp_year = year+"（令和"+(year-2018)+"）";
          } else if (year > 1988) {
            return year-1988 == 1 ? history.jp_year = year+"（昭和64・平成1）" : history.jp_year = year+"（平成"+(year-1988)+"）";
          } else if (year > 1925) {
            return history.jp_year = year+"年（昭和"+(year-1925)+"）";
          }
        })
      }
    }
  },
  methods: {
    fetch_history_list(){
      this.$axios
        .get(this.api_url)
        .then(response => {
          this.history_list = response.data.item.reverse()
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    }
  },
  mounted () {
    this.fetch_history_list()
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/history_index.vue